import { render } from "./KkmTaskList.vue?vue&type=template&id=01a6f3d0"
import script from "./KkmTaskList.vue?vue&type=script&lang=js"
export * from "./KkmTaskList.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/front/sevist-vue3-front-main/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__